import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SkipSelf,
  ViewChild,
} from '@angular/core';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { SearchBarListService } from 'src/app/services/ui/search-bar-list.service';

@Component({
  selector: 'app-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss'],
})
export class SelectorComponent implements OnInit, OnDestroy {
  @ViewChild('dropdownContainer') dropdownMenu!: ElementRef<HTMLElement>;
  @Input() data: string[] = [];
  @Input() showBackButton = false;
  @Input() label?: string;
  @Output() backClick = new EventEmitter<void>();

  public isDropdownOpen$: Observable<boolean> =
    this.searchBarListService.getIsDropdownOpen();

  /** Currently selected option, used to highlight the matching dropdown item. */
  public selectedValue = '';

  private windowClickSubscription!: Subscription;
  /** Timer that closes the dropdown some ms after mouseleave. */
  private closeTimer: any = null;
  private readonly closeDelayMs = 1000;

  constructor(@SkipSelf() private searchBarListService: SearchBarListService) { }

  ngOnInit(): void {
    // Click outside (en window) cierra el dropdown.
    this.windowClickSubscription = fromEvent(window, 'click').subscribe(() => {
      this.cancelCloseTimer();
      this.searchBarListService.setIsDropdownOpen(false);
    });
  }

  ngOnDestroy() {
    this.cancelCloseTimer();
    this.windowClickSubscription?.unsubscribe();
  }

  public selectOption(option: string) {
    this.cancelCloseTimer();
    // Click en la opción ya seleccionada → deselecciona y vuelve al orden
    // sin filtro (tal como llega de la API).
    const nextValue = option === this.selectedValue ? '' : option;
    this.searchBarListService.setFilterSelected(nextValue);
    this.searchBarListService.setIsDropdownOpen(false);
    this.selectedValue = nextValue;
  }

  /** Click en el trigger: toggle del dropdown. */
  public openDropdown(event: Event): void {
    event.stopPropagation();
    this.cancelCloseTimer();
    this.searchBarListService.setIsDropdownOpen(true);
  }

  public closeDropdown(event: Event): void {
    event.stopPropagation();
    this.cancelCloseTimer();
    this.searchBarListService.setIsDropdownOpen(false);
  }

  /** Mouse entra al wrapper → cancela el timer de cierre y abre. */
  public onMouseEnter(): void {
    this.cancelCloseTimer();
    this.searchBarListService.setIsDropdownOpen(true);
  }

  /** Mouse sale del wrapper → arranca timer para cerrar tras `closeDelayMs`. */
  public onMouseLeave(): void {
    this.cancelCloseTimer();
    this.closeTimer = setTimeout(() => {
      this.searchBarListService.setIsDropdownOpen(false);
      this.closeTimer = null;
    }, this.closeDelayMs);
  }

  private cancelCloseTimer(): void {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }
}
